module.exports = __webpack_public_path__ + "static/media/person-lines.76f0e214.svg";